// Generated from java-escape by ANTLR 4.11.1
// jshint ignore: start
import * as antlr4 from 'antlr4';
import DataParserListener from './DataParserListener';
import DataParserVisitor from './DataParserVisitor';

 /* eslint-disable */ 
const serializedATN = [4,1,29,178,2,0,7,0,2,1,7,1,2,2,7,2,2,3,7,3,2,4,7,
4,2,5,7,5,2,6,7,6,2,7,7,7,2,8,7,8,2,9,7,9,2,10,7,10,2,11,7,11,2,12,7,12,
2,13,7,13,2,14,7,14,2,15,7,15,2,16,7,16,2,17,7,17,2,18,7,18,1,0,1,0,3,0,
41,8,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,3,1,50,8,1,1,1,1,1,1,1,5,1,55,8,1,10,
1,12,1,58,9,1,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,
2,1,2,1,2,1,2,3,2,78,8,2,1,2,1,2,1,2,1,2,1,2,1,2,5,2,86,8,2,10,2,12,2,89,
9,2,1,3,1,3,1,3,1,3,1,3,1,4,1,4,1,4,1,4,1,4,1,5,1,5,1,5,1,5,1,5,1,5,1,5,
1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,8,1,8,
1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,10,1,10,1,10,1,
10,1,10,1,11,1,11,1,11,1,11,1,11,1,12,1,12,3,12,152,8,12,1,13,1,13,3,13,
156,8,13,1,14,1,14,1,15,1,15,1,15,1,15,5,15,164,8,15,10,15,12,15,167,9,15,
1,16,1,16,1,17,1,17,1,18,1,18,1,18,3,18,176,8,18,1,18,0,2,2,4,19,0,2,4,6,
8,10,12,14,16,18,20,22,24,26,28,30,32,34,36,0,4,1,0,11,12,1,0,21,22,1,0,
19,20,2,0,14,14,16,16,181,0,40,1,0,0,0,2,49,1,0,0,0,4,77,1,0,0,0,6,90,1,
0,0,0,8,95,1,0,0,0,10,100,1,0,0,0,12,107,1,0,0,0,14,114,1,0,0,0,16,123,1,
0,0,0,18,132,1,0,0,0,20,139,1,0,0,0,22,144,1,0,0,0,24,151,1,0,0,0,26,155,
1,0,0,0,28,157,1,0,0,0,30,159,1,0,0,0,32,168,1,0,0,0,34,170,1,0,0,0,36,175,
1,0,0,0,38,41,3,2,1,0,39,41,5,1,0,0,40,38,1,0,0,0,40,39,1,0,0,0,41,1,1,0,
0,0,42,43,6,1,-1,0,43,44,5,23,0,0,44,45,3,2,1,0,45,46,5,24,0,0,46,50,1,0,
0,0,47,50,3,4,2,0,48,50,3,34,17,0,49,42,1,0,0,0,49,47,1,0,0,0,49,48,1,0,
0,0,50,56,1,0,0,0,51,52,10,4,0,0,52,53,5,19,0,0,53,55,3,2,1,5,54,51,1,0,
0,0,55,58,1,0,0,0,56,54,1,0,0,0,56,57,1,0,0,0,57,3,1,0,0,0,58,56,1,0,0,0,
59,60,6,2,-1,0,60,61,5,23,0,0,61,62,3,4,2,0,62,63,5,24,0,0,63,78,1,0,0,0,
64,65,5,20,0,0,65,78,3,4,2,12,66,78,7,0,0,0,67,78,3,6,3,0,68,78,3,8,4,0,
69,78,3,10,5,0,70,78,3,12,6,0,71,78,3,14,7,0,72,78,3,16,8,0,73,78,3,18,9,
0,74,78,3,20,10,0,75,78,3,22,11,0,76,78,3,30,15,0,77,59,1,0,0,0,77,64,1,
0,0,0,77,66,1,0,0,0,77,67,1,0,0,0,77,68,1,0,0,0,77,69,1,0,0,0,77,70,1,0,
0,0,77,71,1,0,0,0,77,72,1,0,0,0,77,73,1,0,0,0,77,74,1,0,0,0,77,75,1,0,0,
0,77,76,1,0,0,0,78,87,1,0,0,0,79,80,10,15,0,0,80,81,7,1,0,0,81,86,3,4,2,
16,82,83,10,14,0,0,83,84,7,2,0,0,84,86,3,4,2,15,85,79,1,0,0,0,85,82,1,0,
0,0,86,89,1,0,0,0,87,85,1,0,0,0,87,88,1,0,0,0,88,5,1,0,0,0,89,87,1,0,0,0,
90,91,5,2,0,0,91,92,5,23,0,0,92,93,3,24,12,0,93,94,5,24,0,0,94,7,1,0,0,0,
95,96,5,3,0,0,96,97,5,23,0,0,97,98,3,24,12,0,98,99,5,24,0,0,99,9,1,0,0,0,
100,101,5,4,0,0,101,102,5,23,0,0,102,103,3,24,12,0,103,104,5,25,0,0,104,
105,3,24,12,0,105,106,5,24,0,0,106,11,1,0,0,0,107,108,5,5,0,0,108,109,5,
23,0,0,109,110,3,24,12,0,110,111,5,25,0,0,111,112,3,26,13,0,112,113,5,24,
0,0,113,13,1,0,0,0,114,115,5,6,0,0,115,116,5,23,0,0,116,117,3,24,12,0,117,
118,5,25,0,0,118,119,3,24,12,0,119,120,5,25,0,0,120,121,3,24,12,0,121,122,
5,24,0,0,122,15,1,0,0,0,123,124,5,7,0,0,124,125,5,23,0,0,125,126,3,24,12,
0,126,127,5,25,0,0,127,128,3,24,12,0,128,129,5,25,0,0,129,130,3,24,12,0,
130,131,5,24,0,0,131,17,1,0,0,0,132,133,5,8,0,0,133,134,5,23,0,0,134,135,
3,24,12,0,135,136,5,25,0,0,136,137,3,24,12,0,137,138,5,24,0,0,138,19,1,0,
0,0,139,140,5,10,0,0,140,141,5,23,0,0,141,142,3,24,12,0,142,143,5,24,0,0,
143,21,1,0,0,0,144,145,5,9,0,0,145,146,5,23,0,0,146,147,3,24,12,0,147,148,
5,24,0,0,148,23,1,0,0,0,149,152,3,30,15,0,150,152,3,34,17,0,151,149,1,0,
0,0,151,150,1,0,0,0,152,25,1,0,0,0,153,156,3,30,15,0,154,156,3,36,18,0,155,
153,1,0,0,0,155,154,1,0,0,0,156,27,1,0,0,0,157,158,5,15,0,0,158,29,1,0,0,
0,159,165,3,32,16,0,160,161,5,29,0,0,161,164,3,32,16,0,162,164,3,28,14,0,
163,160,1,0,0,0,163,162,1,0,0,0,164,167,1,0,0,0,165,163,1,0,0,0,165,166,
1,0,0,0,166,31,1,0,0,0,167,165,1,0,0,0,168,169,7,3,0,0,169,33,1,0,0,0,170,
171,5,13,0,0,171,35,1,0,0,0,172,173,5,20,0,0,173,176,5,11,0,0,174,176,5,
11,0,0,175,172,1,0,0,0,175,174,1,0,0,0,176,37,1,0,0,0,11,40,49,56,77,85,
87,151,155,163,165,175];


const atn = new antlr4.ATNDeserializer().deserialize(serializedATN);

const decisionsToDFA = atn.decisionToState.map( (ds, index) => new antlr4.DFA(ds, index) );

const sharedContextCache = new antlr4.PredictionContextCache();

export default class DataParser extends antlr4.Parser {

    static grammarFileName = "java-escape";
    static literalNames = [ null, "'null'", "'GetStartDate'", "'GetEndDate'", 
                            "'GetDateRange'", "'AddDays'", "'Replace'", 
                            "'Get'", "'Parse'", "'Upper'", "'Lower'", null, 
                            null, null, null, null, null, null, null, "'+'", 
                            "'-'", "'*'", "'/'", "'('", "')'", "','", "'='", 
                            "'['", "']'", "'.'" ];
    static symbolicNames = [ null, "NULL", "STARTDATE", "ENDDATE", "DATERANGE", 
                             "ADDDAYS", "REPLACE", "GET", "PARSE", "UPPER", 
                             "LOWER", "INTEGER", "DECIMAL", "TEXT", "BRACES", 
                             "LOOKUP", "WORD", "WHITESPACE", "NEWLINE", 
                             "PLUS", "MINUS", "ASTERISK", "DIVISION", "LPAREN", 
                             "RPAREN", "COMMA", "EQUALS", "LBRACKET", "RBRACKET", 
                             "PERIOD" ];
    static ruleNames = [ "line", "concatenation", "expression", "getStartDateFunc", 
                         "getEndDateFunc", "getDateRangeFunc", "addDaysFunc", 
                         "replaceFunc", "getAspectFunc", "parseFunc", "lowerFunc", 
                         "upperFunc", "stringTerm", "intTerm", "args", "name", 
                         "term", "literal", "int" ];

    constructor(input) {
        super(input);
        this._interp = new antlr4.ParserATNSimulator(this, atn, decisionsToDFA, sharedContextCache);
        this.ruleNames = DataParser.ruleNames;
        this.literalNames = DataParser.literalNames;
        this.symbolicNames = DataParser.symbolicNames;
    }

    get atn() {
        return atn;
    }

    sempred(localctx, ruleIndex, predIndex) {
    	switch(ruleIndex) {
    	case 1:
    	    		return this.concatenation_sempred(localctx, predIndex);
    	case 2:
    	    		return this.expression_sempred(localctx, predIndex);
        default:
            throw "No predicate with index:" + ruleIndex;
       }
    }

    concatenation_sempred(localctx, predIndex) {
    	switch(predIndex) {
    		case 0:
    			return this.precpred(this._ctx, 4);
    		default:
    			throw "No predicate with index:" + predIndex;
    	}
    };

    expression_sempred(localctx, predIndex) {
    	switch(predIndex) {
    		case 1:
    			return this.precpred(this._ctx, 15);
    		case 2:
    			return this.precpred(this._ctx, 14);
    		default:
    			throw "No predicate with index:" + predIndex;
    	}
    };




	line() {
	    let localctx = new LineContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 0, DataParser.RULE_line);
	    try {
	        this.state = 40;
	        this._errHandler.sync(this);
	        switch(this._input.LA(1)) {
	        case 2:
	        case 3:
	        case 4:
	        case 5:
	        case 6:
	        case 7:
	        case 8:
	        case 9:
	        case 10:
	        case 11:
	        case 12:
	        case 13:
	        case 14:
	        case 16:
	        case 20:
	        case 23:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 38;
	            this.concatenation(0);
	            break;
	        case 1:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 39;
	            this.match(DataParser.NULL);
	            break;
	        default:
	            throw new antlr4.NoViableAltException(this);
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}


	concatenation(_p) {
		if(_p===undefined) {
		    _p = 0;
		}
	    const _parentctx = this._ctx;
	    const _parentState = this.state;
	    let localctx = new ConcatenationContext(this, this._ctx, _parentState);
	    let _prevctx = localctx;
	    const _startState = 2;
	    this.enterRecursionRule(localctx, 2, DataParser.RULE_concatenation, _p);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 49;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,1,this._ctx);
	        switch(la_) {
	        case 1:
	            localctx = new ConcatParensContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;

	            this.state = 43;
	            this.match(DataParser.LPAREN);
	            this.state = 44;
	            this.concatenation(0);
	            this.state = 45;
	            this.match(DataParser.RPAREN);
	            break;

	        case 2:
	            localctx = new ExprContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 47;
	            this.expression(0);
	            break;

	        case 3:
	            localctx = new TextContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 48;
	            this.literal();
	            break;

	        }
	        this._ctx.stop = this._input.LT(-1);
	        this.state = 56;
	        this._errHandler.sync(this);
	        var _alt = this._interp.adaptivePredict(this._input,2,this._ctx)
	        while(_alt!=2 && _alt!=antlr4.ATN.INVALID_ALT_NUMBER) {
	            if(_alt===1) {
	                if(this._parseListeners!==null) {
	                    this.triggerExitRuleEvent();
	                }
	                _prevctx = localctx;
	                localctx = new ConcatContext(this, new ConcatenationContext(this, _parentctx, _parentState));
	                localctx.left = _prevctx;
	                this.pushNewRecursionContext(localctx, _startState, DataParser.RULE_concatenation);
	                this.state = 51;
	                if (!( this.precpred(this._ctx, 4))) {
	                    throw new antlr4.FailedPredicateException(this, "this.precpred(this._ctx, 4)");
	                }
	                this.state = 52;
	                this.match(DataParser.PLUS);
	                this.state = 53;
	                localctx.right = this.concatenation(5); 
	            }
	            this.state = 58;
	            this._errHandler.sync(this);
	            _alt = this._interp.adaptivePredict(this._input,2,this._ctx);
	        }

	    } catch( error) {
	        if(error instanceof antlr4.RecognitionException) {
		        localctx.exception = error;
		        this._errHandler.reportError(this, error);
		        this._errHandler.recover(this, error);
		    } else {
		    	throw error;
		    }
	    } finally {
	        this.unrollRecursionContexts(_parentctx)
	    }
	    return localctx;
	}


	expression(_p) {
		if(_p===undefined) {
		    _p = 0;
		}
	    const _parentctx = this._ctx;
	    const _parentState = this.state;
	    let localctx = new ExpressionContext(this, this._ctx, _parentState);
	    let _prevctx = localctx;
	    const _startState = 4;
	    this.enterRecursionRule(localctx, 4, DataParser.RULE_expression, _p);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 77;
	        this._errHandler.sync(this);
	        switch(this._input.LA(1)) {
	        case 23:
	            localctx = new ParensContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;

	            this.state = 60;
	            this.match(DataParser.LPAREN);
	            this.state = 61;
	            this.expression(0);
	            this.state = 62;
	            this.match(DataParser.RPAREN);
	            break;
	        case 20:
	            localctx = new NegContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 64;
	            this.match(DataParser.MINUS);
	            this.state = 65;
	            this.expression(12);
	            break;
	        case 11:
	        case 12:
	            localctx = new NumContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 66;
	            _la = this._input.LA(1);
	            if(!(_la===11 || _la===12)) {
	            this._errHandler.recoverInline(this);
	            }
	            else {
	            	this._errHandler.reportMatch(this);
	                this.consume();
	            }
	            break;
	        case 2:
	            localctx = new GetStartDateContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 67;
	            this.getStartDateFunc();
	            break;
	        case 3:
	            localctx = new GetEndDateContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 68;
	            this.getEndDateFunc();
	            break;
	        case 4:
	            localctx = new GetDateRangeContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 69;
	            this.getDateRangeFunc();
	            break;
	        case 5:
	            localctx = new AddDaysContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 70;
	            this.addDaysFunc();
	            break;
	        case 6:
	            localctx = new ReplaceContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 71;
	            this.replaceFunc();
	            break;
	        case 7:
	            localctx = new GetContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 72;
	            this.getAspectFunc();
	            break;
	        case 8:
	            localctx = new ParseContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 73;
	            this.parseFunc();
	            break;
	        case 10:
	            localctx = new LowerContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 74;
	            this.lowerFunc();
	            break;
	        case 9:
	            localctx = new UpperContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 75;
	            this.upperFunc();
	            break;
	        case 14:
	        case 16:
	            localctx = new FieldContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 76;
	            this.name();
	            break;
	        default:
	            throw new antlr4.NoViableAltException(this);
	        }
	        this._ctx.stop = this._input.LT(-1);
	        this.state = 87;
	        this._errHandler.sync(this);
	        var _alt = this._interp.adaptivePredict(this._input,5,this._ctx)
	        while(_alt!=2 && _alt!=antlr4.ATN.INVALID_ALT_NUMBER) {
	            if(_alt===1) {
	                if(this._parseListeners!==null) {
	                    this.triggerExitRuleEvent();
	                }
	                _prevctx = localctx;
	                this.state = 85;
	                this._errHandler.sync(this);
	                var la_ = this._interp.adaptivePredict(this._input,4,this._ctx);
	                switch(la_) {
	                case 1:
	                    localctx = new MulDivContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, DataParser.RULE_expression);
	                    this.state = 79;
	                    if (!( this.precpred(this._ctx, 15))) {
	                        throw new antlr4.FailedPredicateException(this, "this.precpred(this._ctx, 15)");
	                    }
	                    this.state = 80;
	                    localctx.operator = this._input.LT(1);
	                    _la = this._input.LA(1);
	                    if(!(_la===21 || _la===22)) {
	                        localctx.operator = this._errHandler.recoverInline(this);
	                    }
	                    else {
	                    	this._errHandler.reportMatch(this);
	                        this.consume();
	                    }
	                    this.state = 81;
	                    localctx.right = this.expression(16);
	                    break;

	                case 2:
	                    localctx = new AddSubContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, DataParser.RULE_expression);
	                    this.state = 82;
	                    if (!( this.precpred(this._ctx, 14))) {
	                        throw new antlr4.FailedPredicateException(this, "this.precpred(this._ctx, 14)");
	                    }
	                    this.state = 83;
	                    localctx.operator = this._input.LT(1);
	                    _la = this._input.LA(1);
	                    if(!(_la===19 || _la===20)) {
	                        localctx.operator = this._errHandler.recoverInline(this);
	                    }
	                    else {
	                    	this._errHandler.reportMatch(this);
	                        this.consume();
	                    }
	                    this.state = 84;
	                    localctx.right = this.expression(15);
	                    break;

	                } 
	            }
	            this.state = 89;
	            this._errHandler.sync(this);
	            _alt = this._interp.adaptivePredict(this._input,5,this._ctx);
	        }

	    } catch( error) {
	        if(error instanceof antlr4.RecognitionException) {
		        localctx.exception = error;
		        this._errHandler.reportError(this, error);
		        this._errHandler.recover(this, error);
		    } else {
		    	throw error;
		    }
	    } finally {
	        this.unrollRecursionContexts(_parentctx)
	    }
	    return localctx;
	}



	getStartDateFunc() {
	    let localctx = new GetStartDateFuncContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 6, DataParser.RULE_getStartDateFunc);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 90;
	        this.match(DataParser.STARTDATE);
	        this.state = 91;
	        this.match(DataParser.LPAREN);
	        this.state = 92;
	        localctx.dateRange = this.stringTerm();
	        this.state = 93;
	        this.match(DataParser.RPAREN);
	    } catch (re) {
	    	if(re instanceof antlr4.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	getEndDateFunc() {
	    let localctx = new GetEndDateFuncContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 8, DataParser.RULE_getEndDateFunc);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 95;
	        this.match(DataParser.ENDDATE);
	        this.state = 96;
	        this.match(DataParser.LPAREN);
	        this.state = 97;
	        localctx.dateRange = this.stringTerm();
	        this.state = 98;
	        this.match(DataParser.RPAREN);
	    } catch (re) {
	    	if(re instanceof antlr4.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	getDateRangeFunc() {
	    let localctx = new GetDateRangeFuncContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 10, DataParser.RULE_getDateRangeFunc);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 100;
	        this.match(DataParser.DATERANGE);
	        this.state = 101;
	        this.match(DataParser.LPAREN);
	        this.state = 102;
	        localctx.start = this.stringTerm();
	        this.state = 103;
	        this.match(DataParser.COMMA);
	        this.state = 104;
	        localctx.end = this.stringTerm();
	        this.state = 105;
	        this.match(DataParser.RPAREN);
	    } catch (re) {
	    	if(re instanceof antlr4.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	addDaysFunc() {
	    let localctx = new AddDaysFuncContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 12, DataParser.RULE_addDaysFunc);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 107;
	        this.match(DataParser.ADDDAYS);
	        this.state = 108;
	        this.match(DataParser.LPAREN);
	        this.state = 109;
	        localctx.start = this.stringTerm();
	        this.state = 110;
	        this.match(DataParser.COMMA);
	        this.state = 111;
	        localctx.daysToAdd = this.intTerm();
	        this.state = 112;
	        this.match(DataParser.RPAREN);
	    } catch (re) {
	    	if(re instanceof antlr4.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	replaceFunc() {
	    let localctx = new ReplaceFuncContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 14, DataParser.RULE_replaceFunc);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 114;
	        this.match(DataParser.REPLACE);
	        this.state = 115;
	        this.match(DataParser.LPAREN);
	        this.state = 116;
	        localctx.oldValue = this.stringTerm();
	        this.state = 117;
	        this.match(DataParser.COMMA);
	        this.state = 118;
	        localctx.newVaule = this.stringTerm();
	        this.state = 119;
	        this.match(DataParser.COMMA);
	        this.state = 120;
	        localctx.target = this.stringTerm();
	        this.state = 121;
	        this.match(DataParser.RPAREN);
	    } catch (re) {
	    	if(re instanceof antlr4.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	getAspectFunc() {
	    let localctx = new GetAspectFuncContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 16, DataParser.RULE_getAspectFunc);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 123;
	        this.match(DataParser.GET);
	        this.state = 124;
	        this.match(DataParser.LPAREN);
	        this.state = 125;
	        localctx.aspectName = this.stringTerm();
	        this.state = 126;
	        this.match(DataParser.COMMA);
	        this.state = 127;
	        localctx.aspectNames = this.stringTerm();
	        this.state = 128;
	        this.match(DataParser.COMMA);
	        this.state = 129;
	        localctx.aspectValues = this.stringTerm();
	        this.state = 130;
	        this.match(DataParser.RPAREN);
	    } catch (re) {
	    	if(re instanceof antlr4.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	parseFunc() {
	    let localctx = new ParseFuncContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 18, DataParser.RULE_parseFunc);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 132;
	        this.match(DataParser.PARSE);
	        this.state = 133;
	        this.match(DataParser.LPAREN);
	        this.state = 134;
	        localctx.input = this.stringTerm();
	        this.state = 135;
	        this.match(DataParser.COMMA);
	        this.state = 136;
	        localctx.regex = this.stringTerm();
	        this.state = 137;
	        this.match(DataParser.RPAREN);
	    } catch (re) {
	    	if(re instanceof antlr4.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	lowerFunc() {
	    let localctx = new LowerFuncContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 20, DataParser.RULE_lowerFunc);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 139;
	        this.match(DataParser.LOWER);
	        this.state = 140;
	        this.match(DataParser.LPAREN);
	        this.state = 141;
	        localctx.input = this.stringTerm();
	        this.state = 142;
	        this.match(DataParser.RPAREN);
	    } catch (re) {
	    	if(re instanceof antlr4.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	upperFunc() {
	    let localctx = new UpperFuncContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 22, DataParser.RULE_upperFunc);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 144;
	        this.match(DataParser.UPPER);
	        this.state = 145;
	        this.match(DataParser.LPAREN);
	        this.state = 146;
	        localctx.input = this.stringTerm();
	        this.state = 147;
	        this.match(DataParser.RPAREN);
	    } catch (re) {
	    	if(re instanceof antlr4.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	stringTerm() {
	    let localctx = new StringTermContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 24, DataParser.RULE_stringTerm);
	    try {
	        this.state = 151;
	        this._errHandler.sync(this);
	        switch(this._input.LA(1)) {
	        case 14:
	        case 16:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 149;
	            this.name();
	            break;
	        case 13:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 150;
	            this.literal();
	            break;
	        default:
	            throw new antlr4.NoViableAltException(this);
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	intTerm() {
	    let localctx = new IntTermContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 26, DataParser.RULE_intTerm);
	    try {
	        this.state = 155;
	        this._errHandler.sync(this);
	        switch(this._input.LA(1)) {
	        case 14:
	        case 16:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 153;
	            this.name();
	            break;
	        case 11:
	        case 20:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 154;
	            this.int_();
	            break;
	        default:
	            throw new antlr4.NoViableAltException(this);
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	args() {
	    let localctx = new ArgsContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 28, DataParser.RULE_args);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 157;
	        this.match(DataParser.LOOKUP);
	    } catch (re) {
	    	if(re instanceof antlr4.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	name() {
	    let localctx = new NameContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 30, DataParser.RULE_name);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 159;
	        this.term();
	        this.state = 165;
	        this._errHandler.sync(this);
	        var _alt = this._interp.adaptivePredict(this._input,9,this._ctx)
	        while(_alt!=2 && _alt!=antlr4.ATN.INVALID_ALT_NUMBER) {
	            if(_alt===1) {
	                this.state = 163;
	                this._errHandler.sync(this);
	                switch(this._input.LA(1)) {
	                case 29:
	                    this.state = 160;
	                    this.match(DataParser.PERIOD);
	                    this.state = 161;
	                    this.term();
	                    break;
	                case 15:
	                    this.state = 162;
	                    this.args();
	                    break;
	                default:
	                    throw new antlr4.NoViableAltException(this);
	                } 
	            }
	            this.state = 167;
	            this._errHandler.sync(this);
	            _alt = this._interp.adaptivePredict(this._input,9,this._ctx);
	        }

	    } catch (re) {
	    	if(re instanceof antlr4.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	term() {
	    let localctx = new TermContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 32, DataParser.RULE_term);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 168;
	        _la = this._input.LA(1);
	        if(!(_la===14 || _la===16)) {
	        this._errHandler.recoverInline(this);
	        }
	        else {
	        	this._errHandler.reportMatch(this);
	            this.consume();
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	literal() {
	    let localctx = new LiteralContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 34, DataParser.RULE_literal);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 170;
	        this.match(DataParser.TEXT);
	    } catch (re) {
	    	if(re instanceof antlr4.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	int_() {
	    let localctx = new IntContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 36, DataParser.RULE_int);
	    try {
	        this.state = 175;
	        this._errHandler.sync(this);
	        switch(this._input.LA(1)) {
	        case 20:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 172;
	            this.match(DataParser.MINUS);
	            this.state = 173;
	            this.match(DataParser.INTEGER);
	            break;
	        case 11:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 174;
	            this.match(DataParser.INTEGER);
	            break;
	        default:
	            throw new antlr4.NoViableAltException(this);
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}


}

DataParser.EOF = antlr4.Token.EOF;
DataParser.NULL = 1;
DataParser.STARTDATE = 2;
DataParser.ENDDATE = 3;
DataParser.DATERANGE = 4;
DataParser.ADDDAYS = 5;
DataParser.REPLACE = 6;
DataParser.GET = 7;
DataParser.PARSE = 8;
DataParser.UPPER = 9;
DataParser.LOWER = 10;
DataParser.INTEGER = 11;
DataParser.DECIMAL = 12;
DataParser.TEXT = 13;
DataParser.BRACES = 14;
DataParser.LOOKUP = 15;
DataParser.WORD = 16;
DataParser.WHITESPACE = 17;
DataParser.NEWLINE = 18;
DataParser.PLUS = 19;
DataParser.MINUS = 20;
DataParser.ASTERISK = 21;
DataParser.DIVISION = 22;
DataParser.LPAREN = 23;
DataParser.RPAREN = 24;
DataParser.COMMA = 25;
DataParser.EQUALS = 26;
DataParser.LBRACKET = 27;
DataParser.RBRACKET = 28;
DataParser.PERIOD = 29;

DataParser.RULE_line = 0;
DataParser.RULE_concatenation = 1;
DataParser.RULE_expression = 2;
DataParser.RULE_getStartDateFunc = 3;
DataParser.RULE_getEndDateFunc = 4;
DataParser.RULE_getDateRangeFunc = 5;
DataParser.RULE_addDaysFunc = 6;
DataParser.RULE_replaceFunc = 7;
DataParser.RULE_getAspectFunc = 8;
DataParser.RULE_parseFunc = 9;
DataParser.RULE_lowerFunc = 10;
DataParser.RULE_upperFunc = 11;
DataParser.RULE_stringTerm = 12;
DataParser.RULE_intTerm = 13;
DataParser.RULE_args = 14;
DataParser.RULE_name = 15;
DataParser.RULE_term = 16;
DataParser.RULE_literal = 17;
DataParser.RULE_int = 18;

class LineContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = DataParser.RULE_line;
    }

	concatenation() {
	    return this.getTypedRuleContext(ConcatenationContext,0);
	};

	NULL() {
	    return this.getToken(DataParser.NULL, 0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterLine(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitLine(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitLine(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ConcatenationContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = DataParser.RULE_concatenation;
    }


	 
		copyFrom(ctx) {
			super.copyFrom(ctx);
		}

}


class ConcatContext extends ConcatenationContext {

    constructor(parser, ctx) {
        super(parser);
        this.left = null; // ConcatenationContext;
        this.right = null; // ConcatenationContext;
        super.copyFrom(ctx);
    }

	PLUS() {
	    return this.getToken(DataParser.PLUS, 0);
	};

	concatenation = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ConcatenationContext);
	    } else {
	        return this.getTypedRuleContext(ConcatenationContext,i);
	    }
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterConcat(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitConcat(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitConcat(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

DataParser.ConcatContext = ConcatContext;

class ExprContext extends ConcatenationContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

DataParser.ExprContext = ExprContext;

class TextContext extends ConcatenationContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	literal() {
	    return this.getTypedRuleContext(LiteralContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterText(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitText(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitText(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

DataParser.TextContext = TextContext;

class ConcatParensContext extends ConcatenationContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	LPAREN() {
	    return this.getToken(DataParser.LPAREN, 0);
	};

	concatenation() {
	    return this.getTypedRuleContext(ConcatenationContext,0);
	};

	RPAREN() {
	    return this.getToken(DataParser.RPAREN, 0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterConcatParens(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitConcatParens(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitConcatParens(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

DataParser.ConcatParensContext = ConcatParensContext;

class ExpressionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = DataParser.RULE_expression;
    }


	 
		copyFrom(ctx) {
			super.copyFrom(ctx);
		}

}


class UpperContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	upperFunc() {
	    return this.getTypedRuleContext(UpperFuncContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterUpper(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitUpper(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitUpper(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

DataParser.UpperContext = UpperContext;

class ReplaceContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	replaceFunc() {
	    return this.getTypedRuleContext(ReplaceFuncContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterReplace(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitReplace(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitReplace(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

DataParser.ReplaceContext = ReplaceContext;

class LowerContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	lowerFunc() {
	    return this.getTypedRuleContext(LowerFuncContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterLower(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitLower(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitLower(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

DataParser.LowerContext = LowerContext;

class AddDaysContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	addDaysFunc() {
	    return this.getTypedRuleContext(AddDaysFuncContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterAddDays(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitAddDays(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitAddDays(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

DataParser.AddDaysContext = AddDaysContext;

class MulDivContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.left = null; // ExpressionContext;
        this.operator = null; // Token;
        this.right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	DIVISION() {
	    return this.getToken(DataParser.DIVISION, 0);
	};

	ASTERISK() {
	    return this.getToken(DataParser.ASTERISK, 0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterMulDiv(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitMulDiv(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitMulDiv(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

DataParser.MulDivContext = MulDivContext;

class AddSubContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.left = null; // ExpressionContext;
        this.operator = null; // Token;
        this.right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	PLUS() {
	    return this.getToken(DataParser.PLUS, 0);
	};

	MINUS() {
	    return this.getToken(DataParser.MINUS, 0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterAddSub(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitAddSub(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitAddSub(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

DataParser.AddSubContext = AddSubContext;

class ParensContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	LPAREN() {
	    return this.getToken(DataParser.LPAREN, 0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	RPAREN() {
	    return this.getToken(DataParser.RPAREN, 0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterParens(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitParens(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitParens(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

DataParser.ParensContext = ParensContext;

class ParseContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	parseFunc() {
	    return this.getTypedRuleContext(ParseFuncContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterParse(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitParse(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitParse(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

DataParser.ParseContext = ParseContext;

class NumContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	INTEGER() {
	    return this.getToken(DataParser.INTEGER, 0);
	};

	DECIMAL() {
	    return this.getToken(DataParser.DECIMAL, 0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterNum(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitNum(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitNum(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

DataParser.NumContext = NumContext;

class NegContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	MINUS() {
	    return this.getToken(DataParser.MINUS, 0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterNeg(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitNeg(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitNeg(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

DataParser.NegContext = NegContext;

class FieldContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	name() {
	    return this.getTypedRuleContext(NameContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterField(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitField(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitField(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

DataParser.FieldContext = FieldContext;

class GetContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	getAspectFunc() {
	    return this.getTypedRuleContext(GetAspectFuncContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterGet(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitGet(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitGet(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

DataParser.GetContext = GetContext;

class GetEndDateContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	getEndDateFunc() {
	    return this.getTypedRuleContext(GetEndDateFuncContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterGetEndDate(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitGetEndDate(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitGetEndDate(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

DataParser.GetEndDateContext = GetEndDateContext;

class GetDateRangeContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	getDateRangeFunc() {
	    return this.getTypedRuleContext(GetDateRangeFuncContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterGetDateRange(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitGetDateRange(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitGetDateRange(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

DataParser.GetDateRangeContext = GetDateRangeContext;

class GetStartDateContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	getStartDateFunc() {
	    return this.getTypedRuleContext(GetStartDateFuncContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterGetStartDate(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitGetStartDate(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitGetStartDate(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

DataParser.GetStartDateContext = GetStartDateContext;

class GetStartDateFuncContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = DataParser.RULE_getStartDateFunc;
        this.dateRange = null; // StringTermContext
    }

	STARTDATE() {
	    return this.getToken(DataParser.STARTDATE, 0);
	};

	LPAREN() {
	    return this.getToken(DataParser.LPAREN, 0);
	};

	RPAREN() {
	    return this.getToken(DataParser.RPAREN, 0);
	};

	stringTerm() {
	    return this.getTypedRuleContext(StringTermContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterGetStartDateFunc(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitGetStartDateFunc(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitGetStartDateFunc(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class GetEndDateFuncContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = DataParser.RULE_getEndDateFunc;
        this.dateRange = null; // StringTermContext
    }

	ENDDATE() {
	    return this.getToken(DataParser.ENDDATE, 0);
	};

	LPAREN() {
	    return this.getToken(DataParser.LPAREN, 0);
	};

	RPAREN() {
	    return this.getToken(DataParser.RPAREN, 0);
	};

	stringTerm() {
	    return this.getTypedRuleContext(StringTermContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterGetEndDateFunc(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitGetEndDateFunc(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitGetEndDateFunc(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class GetDateRangeFuncContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = DataParser.RULE_getDateRangeFunc;
        this.start = null; // StringTermContext
        this.end = null; // StringTermContext
    }

	DATERANGE() {
	    return this.getToken(DataParser.DATERANGE, 0);
	};

	LPAREN() {
	    return this.getToken(DataParser.LPAREN, 0);
	};

	COMMA() {
	    return this.getToken(DataParser.COMMA, 0);
	};

	RPAREN() {
	    return this.getToken(DataParser.RPAREN, 0);
	};

	stringTerm = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(StringTermContext);
	    } else {
	        return this.getTypedRuleContext(StringTermContext,i);
	    }
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterGetDateRangeFunc(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitGetDateRangeFunc(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitGetDateRangeFunc(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class AddDaysFuncContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = DataParser.RULE_addDaysFunc;
        this.start = null; // StringTermContext
        this.daysToAdd = null; // IntTermContext
    }

	ADDDAYS() {
	    return this.getToken(DataParser.ADDDAYS, 0);
	};

	LPAREN() {
	    return this.getToken(DataParser.LPAREN, 0);
	};

	COMMA() {
	    return this.getToken(DataParser.COMMA, 0);
	};

	RPAREN() {
	    return this.getToken(DataParser.RPAREN, 0);
	};

	stringTerm() {
	    return this.getTypedRuleContext(StringTermContext,0);
	};

	intTerm() {
	    return this.getTypedRuleContext(IntTermContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterAddDaysFunc(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitAddDaysFunc(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitAddDaysFunc(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ReplaceFuncContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = DataParser.RULE_replaceFunc;
        this.oldValue = null; // StringTermContext
        this.newVaule = null; // StringTermContext
        this.target = null; // StringTermContext
    }

	REPLACE() {
	    return this.getToken(DataParser.REPLACE, 0);
	};

	LPAREN() {
	    return this.getToken(DataParser.LPAREN, 0);
	};

	COMMA = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(DataParser.COMMA);
	    } else {
	        return this.getToken(DataParser.COMMA, i);
	    }
	};


	RPAREN() {
	    return this.getToken(DataParser.RPAREN, 0);
	};

	stringTerm = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(StringTermContext);
	    } else {
	        return this.getTypedRuleContext(StringTermContext,i);
	    }
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterReplaceFunc(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitReplaceFunc(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitReplaceFunc(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class GetAspectFuncContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = DataParser.RULE_getAspectFunc;
        this.aspectName = null; // StringTermContext
        this.aspectNames = null; // StringTermContext
        this.aspectValues = null; // StringTermContext
    }

	GET() {
	    return this.getToken(DataParser.GET, 0);
	};

	LPAREN() {
	    return this.getToken(DataParser.LPAREN, 0);
	};

	COMMA = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(DataParser.COMMA);
	    } else {
	        return this.getToken(DataParser.COMMA, i);
	    }
	};


	RPAREN() {
	    return this.getToken(DataParser.RPAREN, 0);
	};

	stringTerm = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(StringTermContext);
	    } else {
	        return this.getTypedRuleContext(StringTermContext,i);
	    }
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterGetAspectFunc(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitGetAspectFunc(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitGetAspectFunc(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ParseFuncContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = DataParser.RULE_parseFunc;
        this.input = null; // StringTermContext
        this.regex = null; // StringTermContext
    }

	PARSE() {
	    return this.getToken(DataParser.PARSE, 0);
	};

	LPAREN() {
	    return this.getToken(DataParser.LPAREN, 0);
	};

	COMMA() {
	    return this.getToken(DataParser.COMMA, 0);
	};

	RPAREN() {
	    return this.getToken(DataParser.RPAREN, 0);
	};

	stringTerm = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(StringTermContext);
	    } else {
	        return this.getTypedRuleContext(StringTermContext,i);
	    }
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterParseFunc(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitParseFunc(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitParseFunc(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class LowerFuncContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = DataParser.RULE_lowerFunc;
        this.input = null; // StringTermContext
    }

	LOWER() {
	    return this.getToken(DataParser.LOWER, 0);
	};

	LPAREN() {
	    return this.getToken(DataParser.LPAREN, 0);
	};

	RPAREN() {
	    return this.getToken(DataParser.RPAREN, 0);
	};

	stringTerm() {
	    return this.getTypedRuleContext(StringTermContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterLowerFunc(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitLowerFunc(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitLowerFunc(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class UpperFuncContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = DataParser.RULE_upperFunc;
        this.input = null; // StringTermContext
    }

	UPPER() {
	    return this.getToken(DataParser.UPPER, 0);
	};

	LPAREN() {
	    return this.getToken(DataParser.LPAREN, 0);
	};

	RPAREN() {
	    return this.getToken(DataParser.RPAREN, 0);
	};

	stringTerm() {
	    return this.getTypedRuleContext(StringTermContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterUpperFunc(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitUpperFunc(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitUpperFunc(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class StringTermContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = DataParser.RULE_stringTerm;
    }

	name() {
	    return this.getTypedRuleContext(NameContext,0);
	};

	literal() {
	    return this.getTypedRuleContext(LiteralContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterStringTerm(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitStringTerm(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitStringTerm(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class IntTermContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = DataParser.RULE_intTerm;
    }

	name() {
	    return this.getTypedRuleContext(NameContext,0);
	};

	int_() {
	    return this.getTypedRuleContext(IntContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterIntTerm(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitIntTerm(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitIntTerm(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ArgsContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = DataParser.RULE_args;
    }

	LOOKUP() {
	    return this.getToken(DataParser.LOOKUP, 0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterArgs(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitArgs(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitArgs(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class NameContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = DataParser.RULE_name;
    }

	term = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(TermContext);
	    } else {
	        return this.getTypedRuleContext(TermContext,i);
	    }
	};

	PERIOD = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(DataParser.PERIOD);
	    } else {
	        return this.getToken(DataParser.PERIOD, i);
	    }
	};


	args = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ArgsContext);
	    } else {
	        return this.getTypedRuleContext(ArgsContext,i);
	    }
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterName(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitName(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitName(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class TermContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = DataParser.RULE_term;
    }

	BRACES() {
	    return this.getToken(DataParser.BRACES, 0);
	};

	WORD() {
	    return this.getToken(DataParser.WORD, 0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterTerm(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitTerm(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitTerm(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class LiteralContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = DataParser.RULE_literal;
    }

	TEXT() {
	    return this.getToken(DataParser.TEXT, 0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterLiteral(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitLiteral(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitLiteral(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class IntContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = DataParser.RULE_int;
    }

	MINUS() {
	    return this.getToken(DataParser.MINUS, 0);
	};

	INTEGER() {
	    return this.getToken(DataParser.INTEGER, 0);
	};

	enterRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.enterInt(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof DataParserListener ) {
	        listener.exitInt(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof DataParserVisitor ) {
	        return visitor.visitInt(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}




DataParser.LineContext = LineContext; 
DataParser.ConcatenationContext = ConcatenationContext; 
DataParser.ExpressionContext = ExpressionContext; 
DataParser.GetStartDateFuncContext = GetStartDateFuncContext; 
DataParser.GetEndDateFuncContext = GetEndDateFuncContext; 
DataParser.GetDateRangeFuncContext = GetDateRangeFuncContext; 
DataParser.AddDaysFuncContext = AddDaysFuncContext; 
DataParser.ReplaceFuncContext = ReplaceFuncContext; 
DataParser.GetAspectFuncContext = GetAspectFuncContext; 
DataParser.ParseFuncContext = ParseFuncContext; 
DataParser.LowerFuncContext = LowerFuncContext; 
DataParser.UpperFuncContext = UpperFuncContext; 
DataParser.StringTermContext = StringTermContext; 
DataParser.IntTermContext = IntTermContext; 
DataParser.ArgsContext = ArgsContext; 
DataParser.NameContext = NameContext; 
DataParser.TermContext = TermContext; 
DataParser.LiteralContext = LiteralContext; 
DataParser.IntContext = IntContext; 
